import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { ChartsService } from '../../../../services/chartService/charts.service';
import { ChartSpecification } from '../../../../dataModels/chart-data-model';

declare var AmCharts;

@Component({
    moduleId: module.id,
    selector: 'simple-column-chart',
    templateUrl: 'simple-column-chart.component.html',
    styleUrls: ['simple-column-chart.component.css', '../../charts.style.scss']
})

export class SimpleColumnChartComponent implements OnInit, AfterViewInit {
    @Input() chartSpecification: ChartSpecification;

    ignoreAxisWidth: boolean = true;
    autoWrap: boolean = true;

    constructor() { }

    ngOnInit() {
        this.chartSpecification.title = this.chartSpecification.title || "";
        this.chartSpecification.theme = this.chartSpecification.theme || "none";
        this.chartSpecification.chartColor = this.chartSpecification.chartColor || "";
        this.chartSpecification.data = this.chartSpecification.data || [];
        this.chartSpecification.yAxisTitle = this.chartSpecification.yAxisTitle || "";
        this.chartSpecification.xAxis = this.chartSpecification.xAxis || "xAxis";
        this.chartSpecification.yAxis = this.chartSpecification.yAxis || "yAxis";
        this.chartSpecification.divId = this.chartSpecification.divId || "columnDiv";
        this.chartSpecification.valueAxes = this.chartSpecification.valueAxes || [];
        this.chartSpecification.rotate = this.chartSpecification.rotate || false;
        this.chartSpecification.EnableValueAxisLabels = this.chartSpecification.EnableValueAxisLabels || false;
        this.chartSpecification.yAxisAutoGridCount = this.chartSpecification.yAxisAutoGridCount || false;
        this.chartSpecification.categoryLabelLength = this.chartSpecification.categoryLabelLength || 0;
        this.chartSpecification.precision = this.chartSpecification.precision || 0;

        if (typeof this.chartSpecification.yAxisGridAlpha == "undefined") {
            this.chartSpecification.yAxisGridAlpha = 0.2;
        }

        // if chart is rotated, there is no need to wrap x-axis labels
        if (this.chartSpecification.rotate) {
            this.autoWrap = false;
            this.ignoreAxisWidth = false;
        }
    }

    ngAfterViewInit() {
        this.drawChart();
    }

    drawChart() {
        setTimeout(() => {
            AmCharts.makeChart(this.chartSpecification.divId, {
                "hideCredits": true,
                "type": "serial",
                "theme": this.chartSpecification.theme,
                "rotate": this.chartSpecification.rotate,
                "dataProvider": this.chartSpecification.data,
                "titles": [{
                    "size": 12,
                    "text": this.chartSpecification.title
                }],
                "valueAxes": [{
                    "gridAlpha": this.chartSpecification.yAxisGridAlpha,
                    "autoGridCount": this.chartSpecification.yAxisAutoGridCount,
                    "gridCount": 10,
                    "dashLength": 0,
                    "axisThickness": 0,
                    "axisAlpha": 0,
                    "labelsEnabled": this.chartSpecification.EnableValueAxisLabels,
                    "title": this.chartSpecification.yAxisTitle
                }],
                "gridAboveGraphs": true,
                "graphs": [{
                    "balloonText": "[[category]]: <b>[[value]]</b>",
                    "fillAlphas": 1,
                    "lineAlpha": 1,
                    "type": "column",
                    "valueField": this.chartSpecification.yAxis,
                    "lineColor": this.chartSpecification.chartColor,
                    "fillColorsField": "color",
                    "customBulletField": "bullet",
                    "bulletOffset": 10,
                    "bulletSize": 25,
                    "precision": this.chartSpecification.precision
                }],
                "chartCursor": {
                    "categoryBalloonEnabled": false,
                    "cursorAlpha": 0,
                    "zoomable": false
                },
                "categoryField": this.chartSpecification.xAxis,
                "categoryAxis": {
                    "gridPosition": "start",
                    "gridAlpha": 0,
                    "tickLength": 0,
                    "autoWrap": this.autoWrap,
                    "ignoreAxisWidth": this.ignoreAxisWidth,
                    "position": "left",
                    "labelFunction": this.truncateLabel.bind(this)
                },
                "export": {
                    "enabled": true,
                    "fileName": this.chartSpecification.title
                }
            });
        }, 20);
    }

    truncateLabel(valueText, serialDataItem, categoryAxis) {
        if (this.chartSpecification.categoryLabelLength > 0 && valueText.length > this.chartSpecification.categoryLabelLength)
            return valueText.substring(0, this.chartSpecification.categoryLabelLength) + '...';
        else
            return valueText;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/barCharts/simple-column-chart/simple-column-chart.component.ts